import angular  from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing  from './device_type_select.routes';

import CompanyService from '../../../../components/api/company/company.service';
import DistStockService from '../../../../components/api/dist_stock/dist_stock.service';
import ServiceStockService from '../../../../components/api/service_stock/service_stock.service';

export class DeviceTypeSelectController {
  /*@ngInject*/
  constructor($state, $stateParams, CompanyService, DistStockService, ServiceStockService) {
    this.company_id = $stateParams.company_id;
    this.$state = $state;
    this.CompanyService      = CompanyService;
    this.DistStockService    = DistStockService;
    this.ServiceStockService = ServiceStockService;
  }

  $onInit() {
    this.CompanyService.show({ id: this.company_id }, response => {
      this.company = response;
    }, err => {
      if(err.status === 404 || err.status === 403) { this.$state.go('oem_main.oem_home'); }
    });

    this.DistStockService.oem_api.count(response => {
      this.tssCount    = response.tss;
      this.tswCount    = response.tsw;
      this.deviceCount = response.tss + response.tsw;
    });

    this.ServiceStockService.oem_api.count(response => {
      this.dssCount = response.dss;
      this.dscCount = response.dsc;
    });
  }
}

export default angular.module('leptonApp.deviceTypeSelect', [uiRouter, CompanyService, DistStockService, ServiceStockService])
  .config(routing)
  .component('deviceTypeSelect', {
    template: require('./device_type_select.html'),
    controller: DeviceTypeSelectController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/type_select/device_type_select.component.js